module.exports = __webpack_public_path__ + "jtails-build/img/banner@2.19a37b7c.jpg";